import { render, staticRenderFns } from "./kdocApps.vue?vue&type=template&id=7b45e450&scoped=true&"
import script from "./kdocApps.vue?vue&type=script&lang=ts&"
export * from "./kdocApps.vue?vue&type=script&lang=ts&"
import style0 from "./kdocApps.vue?vue&type=style&index=0&id=7b45e450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b45e450",
  null
  
)

export default component.exports